<template>
  <button
    class="buttons__item"
    :style="{
      'background-color': backgroundColor,
      color: fontColor,
      'border-color': borderColor,
      'font-size': fontSize,
      padding: padding,
      height: height,
      'line-height': lineHeight ? lineHeight : fontSize,
      width: width,
    }"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    fontColor: {
      type: String,
      default: () => '#ffffff',
    },
    fontSize: {
      type: String,
      default: () => '15px',
    },
    lineHeight: {
      type: String,
      default: () => '15px',
    },
    backgroundColor: {
      type: String,
      default: () => '#ee396c',
    },
    borderColor: {
      type: String,
      default: () => 'transparent',
    },
    padding: {
      type: String,
      default: () => '0 12px',
    },
    height: {
      type: String,
      default: () => '40px',
    },
    width: {
      type: String,
      default: () => 'auto',
    },
  },
  data() {
    return {
      isMobile: window.innerWidth <= 576,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.buttons {
  &__item {
    @media (max-width: $md) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    text-transform: none;
    border-radius: 6px;
    font-weight: 500;
    border: 1px solid transparent;
    svg,
    i {
      color: inherit;
    }
  }
}
</style>
